import React from "react";
import Header from "../../components/header/header.component";
import DisplayCatsCards from "../../components/projects/displayCatsCards/displayCatsCards";

const Home = () => {
  return (
    <>
      <Header />
      <DisplayCatsCards />
    </>
  );
};

export default Home;
